<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          />
          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>

      </div>
      <b-table
        ref="refUserListTable"
        class="position-relative text-nowrap"
        :items="customers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :filter="searchQuery"
        empty-text="No matching records found"
      >

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.claims.photoURL"
                :text="avatarText(data.item.fullName)"
              />
            </template>
            <b-link
              :to="{ name: '', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small
              class="text-muted text-nowrap"
            >
              {{ data.item.claims.displayName }}
            </small>
          </b-media>
        </template>

        <!-- Column: Last Visit -->
        <template #cell(lastVisit)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.records.lastVisit.toDate() | moment("YYYY/MM/DD HH:mm") }}</span>
          </div>
        </template>

        <!-- Column: Total records -->
        <template #cell(totalRecords)="data">
          <div class="text-nowrap text-center">
            <span class="align-text-top text-center">{{ data.item.records.totalRecords }}</span>
          </div>
        </template>

        <!-- Column: Records Between Days -->
        <template #cell(recordsBetweenDays)="data">
          <div class="text-nowrap text-center">
            <span class="align-text-top">{{ avgDays(data.item.createAt, data.item.records.totalRecords) }}</span>
          </div>
        </template>

        <!-- Column: Campaign Name -->
        <template #cell(campaignName)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.campaign.campaignName }}</span>
          </div>
        </template>

        <!-- Column: Provider -->
        <template #cell(provider)="data">
          <div class="text-nowrap">
            <span class="align-item-center text-capitalize">{{ data.item.claims.provider }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!-- <b-dropdown-item :to="{ name: 'appss-view', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item> -->

            <!-- <b-dropdown-item :to="{ name: 'apps-users-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item> -->

            <b-dropdown-item
              @click="confirmDelete({ uid: data.item.campaign.cuid, id: data.item.id })"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BAvatar,
  BBadge, BDropdown, BDropdownItem, BPagination, BLink,
} from 'bootstrap-vue'
import store from '@/store'
import { mapGetters } from 'vuex'
import { avatarText } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BLink,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
  },
  data() {
    return {
      avatarText,
      totalUsers: 0,
      searchQuery: '',
      tableColumns: [
        { key: 'user', label: '姓名' },
        { key: 'phoneNumber', label: '電話' },
        { key: 'email' },
        { key: 'campaignName', label: '活動名稱' },
        { key: 'lastVisit', label: '最後一次打卡' },
        { key: 'totalRecords', label: '打卡次數' },
        { key: 'recordsBetweenDays', label: '平均打卡天數' },
        { key: 'actions', label: '設定' },
      ],
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
      perPage: 50,
      currentPage: 1,
    }
  },
  computed: {
    ...mapGetters(['customers']),
  },
  mounted() {
    this.fetchCustomers()
  },
  methods: {
    fetchCustomers() {
      store.dispatch('fetchCustomers').then(response => {
        this.totalUsers = response.length
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    },
    avgDays(date, count) {
      const today = this.$moment()
      const given = this.$moment(date.toDate())
      const days = today.diff(given, 'days')
      return Math.round(days / count)
    },
    confirmDelete({ uid, id }) {
      this.$swal({
        title: '確定要刪除嗎?',
        text: '刪除以後便無法恢復！',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定, 刪除！',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('deleteCampaignCustomer', { uid, id })
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: '顧客已成功刪除',
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                },
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
